module.exports = __webpack_public_path__ + "media/images/donation/logo-seven-d956e1eaab5120a2ca3d42abc2af70ee.jpg";